import { render, staticRenderFns } from "./my_message.vue?vue&type=template&id=b8156510&scoped=true&"
import script from "./my_message.vue?vue&type=script&lang=js&"
export * from "./my_message.vue?vue&type=script&lang=js&"
import style0 from "./my_message.vue?vue&type=style&index=0&id=b8156510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8156510",
  null
  
)

export default component.exports